import * as _ from 'lodash';
import { IDictionary } from '../shared/shared-types';

export interface IAdService {
    setRenderCallback: (renderCallback: () => void) => void;
    getAdBlocks: (groupId: string) => Array<HTMLElement>,    
    refreshAdBlocks: () => void;
}

export class AdService implements IAdService {

    private _initialized: boolean = false;
    private _gtp: any;
    private _adBlocks: IDictionary<HTMLElement[]>;    

    private get gtp(): any {
        return window['googletag'];
    }

    private get gtpCmd(): Array<Function> {
        return (this.gtp.cmd as Array<Function>);
    }

    constructor() { }    

    public setRenderCallback(renderCallback: () => void): void {

        if (_.isNil(this.gtp)) {
            console.error(`AdService: googletag variable is undefined`);
            return;
        }

        // Queue up methods to execute when gtp is ready              
        this.gtpCmd.push(() => {            
            this.fillFromDOM();
            renderCallback();
        });

    }

    public getAdBlocks(groupId: string = "default"): Array<HTMLElement> {
        return this._adBlocks[groupId] || new Array<HTMLElement>();
    }

    public refreshAdBlocks(): void {
        if (this._initialized) {
            this.gtp.pubads().refresh();
        }
    }

    private fillFromDOM(): void {

        const adContainer = document.getElementById('ad-container');
        if (_.isNil(adContainer)) {
            console.error(`AdService: container is undefined`);
            return;
        }
        
        const adBlocks: Array<HTMLElement> = Array.prototype.slice.call(adContainer.querySelectorAll('.ad-block'));        
        const adBlockMap: IDictionary<Array<HTMLElement>> = { };
        adBlocks.forEach((x) => {
            const groupId = x.parentElement.dataset.groupId || 'default';
            if (_.isNil(adBlockMap[groupId])) {
                adBlockMap[groupId] = new Array<HTMLElement>();
            }
            adBlockMap[groupId].push(x);
        });        
        
        this._adBlocks = adBlockMap;
        adContainer.parentNode.removeChild(adContainer);
        this._initialized = true;
    }

}


// WEBPACK FOOTER //
// ./~/source-map-loader!./app/src/shared/ad-service.ts